module.exports = __webpack_public_path__ + "img/news14-0.7d96562a.png";